import { Component, OnInit } from '@angular/core';
import { ConfirmState } from 'src/app/shared/dialogs/models/ConfirmState';
import { MsgOptionsCookie } from 'src/app/shared/dialogs/models/MsgOptionsCookie';
import { createCookie } from 'src/app/shared/framework/cookies/Cookies';

@Component({
  selector: 'app-cookie-modal',
  templateUrl: './cookie-modal.component.html',
  styleUrls: ['./cookie-modal.component.scss']
})
export class CookieModalComponent implements OnInit {
  cookieOptions: MsgOptionsCookie;

  showPolicy: boolean = false;

  constructor(private state: ConfirmState) {
    this.cookieOptions = state.cookieOptions;
  }

  ngOnInit(): void {
  }

  close() {
    createCookie('complianceCookie', 'on', 14);
    this.state.modal.dismiss();
  }
  showcookiepolicy() {
    this.showPolicy = true;
  }
  back() {
    this.showPolicy = false;
  }
}
